'use strict';

import $ from 'jquery';
import enquire from 'enquire.js';

export default class SiteNav {
  constructor() {

    let $siteNav = $('.site-nav');
    let $siteNavItems = $('li', $siteNav);
    let $lvl1 = $('.site-nav__list', $siteNav);
    let $lvl1Links = $('> li', $lvl1);
    let $lvl2 = $('.site-nav__lvl2');
    let $lvl2Links = $('> li', $lvl2);
    let $backMenuBtn = $('.btn-back', $siteNav);

    this.$siteNav = $siteNav;
    this.$siteNavItems = $siteNavItems;

    let hoverTimeout;

    enquire.register("screen and (max-width: 1023px)", {
      match: () => {

        $lvl1Links.map((j, lvl1Link) => {
          let $lvl1Link = $(lvl1Link);
          let $lvl1Item = $('> .site-nav__link', lvl1Link);
          let $lvl1Icon = $('<span class="icon icon-angle-down"></span>');

          if ($lvl1Link.find('.site-nav__lvl2').length) {
            $lvl1Link.find('> .site-nav__link').append($lvl1Icon);

            $lvl1Item.on('click', e => {
              e.preventDefault();

              let expanded = $lvl1Link.data('expanded');

              if (expanded) {
                this.collapseChild($lvl1Link);

              } else {
                this.expandChild($lvl1Link);
              }
            });
          }
        });

        $lvl2Links.map((j, lvl2Link) => {
          let $lvl2Link = $(lvl2Link);
          let $lvl2Icon = $('<span class="icon icon-angle-down"></span>');

          if ($lvl2Link.find('.site-nav__lvl3').length) {
            $lvl2Link.append($lvl2Icon);

            $lvl2Icon.on('click', e => {
              // e.preventDefault();
              let expanded = $lvl2Link.data('expanded');

              if (expanded) {
                this.collapselvl3($lvl2Link);

              } else {
                this.expandlvl3($lvl2Link);
              }
            });
          }
        });
      },
      unmatch: () => {

      }
    });

    enquire.register("screen and (min-width: 1024px)", {
      match: () => {

        $lvl1Links.map((i, lvl1Link) => {
          let $this = $(lvl1Link);
          let target = $this.data('target');
          let $lvl1Link = $(lvl1Link);

          $this.on('mouseenter', () => {

            hoverTimeout = setTimeout(() => {
              $lvl1Links.removeClass('active');
              $this.addClass('active');
              this.expandChild($lvl1Link);

            }, 200);
          });

          $this.on('focusin', () => {
            
            hoverTimeout = setTimeout(() => {
              $lvl1Links.removeClass('active');
              $this.addClass('active');
              this.expandChild($lvl1Link);
            }, 200);
          });
        
        });

        // $lvl1Links.on('focusout', () => {
        //   clearTimeout(hoverTimeout);
        //   this.closeLevelTwo();

        //   $('.site-nav__lvl2').slideUp();
        // });

        $lvl1Links.on('mouseleave', e => {

          clearTimeout(hoverTimeout);
          this.closeLevelTwo();

          $('.site-nav__lvl2').slideUp();
        });

        $lvl2Links.map((j, lvl2Link) => {
          let $lvl2Link = $(lvl2Link);
          let $lvl2Icon = $('<span class="icon icon-angle-right"></span>');

          if ($lvl2Link.find('.site-nav__lvl3').length) {
            $lvl2Link.append($lvl2Icon);

            $lvl2Link.on('mouseenter', () => {
              hoverTimeout = setTimeout(() => {
                $lvl2Links.removeClass('active');
                $lvl2Link.addClass('active');
                this.expandChild($lvl2Link);
                $lvl2Link.find('.site-nav__lvl3').show();
              }, 200);
            });

            $lvl2.on('focusin', () => {
              hoverTimeout = setTimeout(() => {
                $lvl2Links.removeClass('active');
                $lvl2Link.addClass('active');
                this.expandChild($lvl2Link);
                $lvl2Link.find('.site-nav__lvl3').show();
              }, 200);
            });
          
          }
        });

        $lvl2Links.on('mouseleave', () => {
          clearTimeout(hoverTimeout);
          $('.site-nav__lvl3').slideUp();
        });

      },
      unmatch: () => {

      }
    });


  }

  closeLevelTwo() {
    this.$siteNavItems.removeClass('active');
    this.$siteNavItems.removeClass('expanded');
  }

  expandLevelTwo(target) {
    this.$siteNav.addClass('lvl2-expanded');
    this.lvl2Expanded = true;

    let $target = $(target);

    $target.show(0, () => {
      $target.addClass('is-shown');
    });
  }

  backLevelOne() {
    this.$siteNav.removeClass('lvl2-expanded');
    this.lvl2Expanded = false;

    setTimeout(() => {
      $('.site-nav__lvl2').hide(0);
    }, 250);
  }

  expandChild($parent) {
    $parent.data('expanded', true);
    $parent.addClass('expanded');

    let $expandedSibling = $parent.siblings('.expanded');
    this.collapseChild($expandedSibling);

    let $lvl2 = $('.site-nav__lvl2', $parent);
    $lvl2.slideDown();

    $parent.find('> .site-nav__link > .icon').removeClass('icon-angle-down').addClass('icon-angle-up');
  }

  collapseChild($parent) {
    $parent.data('expanded', false);
    $parent.removeClass('expanded');
    let $lvl2 = $('.site-nav__lvl2', $parent);
    $lvl2.slideUp();

    $parent.find('> .site-nav__link > .icon').removeClass('icon-angle-up').addClass('icon-angle-down');
  }

  expandlvl3($child) {
    $child.data('expanded', true);
    $child.addClass('expanded');

    let $expandedSibling = $child.siblings('.expanded');
    this.collapseChild($expandedSibling);

    let $lvl3 = $('.site-nav__lvl3', $child);
    $lvl3.slideDown();

    $child.find('.icon').removeClass('icon-angle-down').addClass('icon-angle-up');
  }

  collapselvl3($child) {
    $child.data('expanded', false);
    $child.removeClass('expanded');
    let $lvl3 = $('.site-nav__lvl3', $child);
    $lvl3.slideUp();

    $child.find('.icon').removeClass('icon-angle-up').addClass('icon-angle-down');
  }
}
